import React, {Component} from "react";
import {connect} from "react-redux";
import {translate} from "react-i18nify";

import * as keyCodes from "../../constants/keyCodes";
import * as loginActions from "../../actions/loginActions";
import * as keyBoardActions from "../../actions/virtualKeyboardActions";

import Input from "./generic/Input";
import Button from "./generic/Button";

/**
 * @class LoginForm
 *
 */
class LoginForm extends Component {
    loopCounter = 0;

    constructor(props) {
        super(props);

        this.state = {
            login: props.verifyPasswordOnly ? props.loggedUser.login : "",
            password: "",
            showPassword: false
        };
    }

    componentDidMount = () => {
        if (this.props.redlikeLightSoftware || this.props.gammaSoftware) {
            if (!this.props.verifyPasswordOnly) {
                window.jQuery("#keyboard-username").on("change", this.handleUsernameChange);
                window.jQuery("#keyboard-username").on("keydown", this.handleUsernameInputKeyDown);
                if (!this.props.keyboardState && this.props.virtualKeyboardEnabled) {
                    this.props.dispatchSetUniversalKeyboardStateAction(true, "keyboard-username");
                }
            } else {
                if (!this.props.keyboardState && this.props.virtualKeyboardEnabled) {
                    this.props.dispatchSetUniversalKeyboardStateAction(true, "keyboard-password");
                }
            }

            window.jQuery("#keyboard-password").on("change", this.handlePasswordChange);
            window.jQuery("#keyboard-password").on("keydown", this.handlePasswordInputKeyDown);
        }
    };

    componentWillUnmount() {
        window.jQuery("#keyboard-username").unbind("change");
        window.jQuery("#keyboard-password").unbind("change");
        window.jQuery("#keyboard-username").unbind("keydown");
        window.jQuery("#keyboard-password").unbind("keydown");
    }

    handleShowPasswordClick = () => {
        this.setState({
            showPassword: !this.state.showPassword
        });
    };

    handleUsernameInputFocus = () => {
        if (this.props.keyboardState && this.loopCounter < 11) {
            this.loopCounter++;
            this.props.dispatchSetUniversalKeyboardStateAction(true, "keyboard-username");
        }
    };

    handlePasswordInputFocus = () => {
        if (this.props.keyboardState && this.loopCounter < 11) {
            this.loopCounter++;
            this.props.dispatchSetUniversalKeyboardStateAction(true, "keyboard-password");
        }
    };

    handleUsernameInputKeyDown = (event) => {
        if (event.keyCode === keyCodes.TAB || event.keyCode === keyCodes.ENTER) {
            this.loopCounter = 0;
            event.preventDefault();
            event.target.blur();
            window.jQuery("#keyboard-password").focus();
        }
    };

    handlePasswordInputKeyDown = (event) => {
        if (event.shiftKey) {
            if (event.keyCode === keyCodes.TAB && !this.props.verifyPasswordOnly) {
                this.loopCounter = 0;
                event.preventDefault();
                event.target.blur();
                window.jQuery("#keyboard-username").focus();
            }
        }

        if (!event.shiftKey) {
            if (event.keyCode === keyCodes.TAB) {
                this.loopCounter = 0;
                event.preventDefault();
                event.target.blur();
                window.jQuery("#log-in-as-btn").focus();
            }
        }

        if (event.keyCode === keyCodes.ENTER) {
            this.loopCounter = 0;
            event.preventDefault();
            event.target.blur();
            this.handleLogInClick();
        }
    };

    handleUsernameChange = (event) => {
        this.setState({login: event.target.value});
        this.loopCounter = 0;
        this.props.dispatchSetLoginAction(event.target.value === "" ? null : event.target.value);
    };

    handlePasswordChange = (event) => {
        this.setState({password: event.target.value});
        this.loopCounter = 0;
        this.props.dispatchSetPasswordAction(event.target.value === "" ? null : event.target.value);
    };

    handleLogInClick = () => {
        var sha256 = require("sha256");
        const hash = sha256(this.state.password).toUpperCase();
        this.props.logIn(this.state.login, hash);
    };

    getButtons = () => {
        return (
            <Button
                id="log-in-as-btn"
                className="text-uppercase"
                onClick={this.handleLogInClick}
                disabled={this.state.login === "" || this.state.password === ""}
                elementProps={{
                    onKeyDown:
                        this.state.login === "" || this.state.password === ""
                            ? () => {}
                            : this.handleLoginButtonInputKeyDown
                }}
                label={this.props.verifyPasswordOnly ? translate("login.authenticate") : translate("login.logIn")}
            />
        );
    };

    render() {
        return (
            <div className="login-window background-color-light-extra" style={{WebkitAppRegion: "no-drag"}}>
                <div className="redlike-logo">
                    <div className="redlike-logo-blue" />
                </div>
                <div className="login-form">
                    <div className="col-12 flex flex-align-center login-form-input-group">
                        <div className="color-primary col-5 text-right padding-right-10 login-form-label">
                            {translate("login.username") + ":"}
                        </div>
                        <div className="col-7 flex flex-align-start login-form-input">
                            <Input
                                id="keyboard-username"
                                className="col-8 primary-input login-form-input"
                                value={this.state.login}
                                onFocus={this.handleUsernameInputFocus}
                                onChange={this.handleUsernameChange}
                                disabled={this.props.verifyPasswordOnly ?? false}
                                elementProps={{
                                    autoFocus: !this.props.verifyPasswordOnly,
                                    onKeyDown: this.handleUsernameInputKeyDown
                                }}
                            />
                        </div>
                    </div>
                    <div className="col-12 flex flex-align-center margin-top-10 login-form-input-group">
                        <div className="color-primary col-5 text-right padding-right-10 login-form-label">
                            {translate("login.password") + ":"}
                        </div>
                        <div className="col-7 flex flex-align-start login-form-input">
                            <Input
                                id="keyboard-password"
                                className="col-8 primary-input login-form-input"
                                type={this.state.showPassword ? "text" : "password"}
                                value={this.state.password}
                                onFocus={this.handlePasswordInputFocus}
                                onChange={this.handlePasswordChange}
                                elementProps={{
                                    autoFocus: this.props.verifyPasswordOnly ?? false,
                                    onKeyDown: this.handlePasswordInputKeyDown
                                }}
                                labelAfter={
                                    this.state.showPassword ? (
                                        <span
                                            className="glyphicon glyphicon-eye-close cursor-pointer"
                                            aria-hidden="true"
                                            onClick={this.handleShowPasswordClick}
                                        />
                                    ) : (
                                        <span
                                            className="glyphicon glyphicon-eye-open cursor-pointer"
                                            aria-hidden="true"
                                            onClick={this.handleShowPasswordClick}
                                        />
                                    )
                                }
                            />
                        </div>
                    </div>
                    <div className="col-12 flex flex-align-center margin-top-10 login-form-input-group">
                        <div className="col-5" />
                        <div className="col-7 flex flex-align-start btn-group flex-gap-10px">{this.getButtons()}</div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        loggedUser: store.login.loggedUser,
        login: store.login.login,
        redlikeLightSoftware: store.module.redlikeLightSoftware,
        keyboardState: store.virtualKeyboard.keyboardState,
        gammaSoftware: store.module.gammaSoftware,
        virtualKeyboardEnabled: store.settings.virtualKeyboardEnabled
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchSetLoginAction: (login) => {
            dispatch(loginActions.setLogin(login));
        },
        dispatchSetPasswordAction: (password) => {
            dispatch(loginActions.setPassword(password));
        },
        dispatchSetUniversalKeyboardStateAction: (state, selector) => {
            dispatch(keyBoardActions.setUniversalKeyboardState(state, selector));
        }
    };
};

export default LoginForm = connect(mapStoreToProps, mapDispatchToProps)(LoginForm);
